import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { WIRELINE_REQUEST_TYPES_ID as WIRELINEREQUESTIDS } from '../../../../constants/external-constants';
import { valueExist } from '../../../../utils/helpers.utils';
import Translation from "../../../common/translation/translation.component";
import Icons from "../../../icon";

class RequestOwnerDetails extends Component {
    constructor(props) {
        super(props);
    }

    renderManagerDisplay = (isWireline) => {
        const { data } = this.props;
        const { employeeList, requestOnBehalfData } = this.props.createRequest;
        const { newUser } = this.props.wirelessChangeUserRequest
        let display;

        if (requestOnBehalfData.EmployeeId > 0 && Object.keys(newUser).length === 0) {
            display =
                <div>
                    <h6 className="owner-detail-info-title"><Translation translationKey="approver_details" /></h6>
                    <h5 className="owner-detail-info-owner-name">
                        {requestOnBehalfData.CostCodeApproverFullName != null ?
                            requestOnBehalfData.CostCodeApproverFullName :
                            employeeList !== null && employeeList.length > 0 ?
                                employeeList[0].CostCodeApproverFullName :
                                'N/A'
                        }
                    </h5>
                    <div className="owner-detail-contacts">
                        <Icons
                            customClassName="icon-email"
                            name="envelope"
                            labelValue={requestOnBehalfData.CostCodeApproverEmailAddress != null ?
                                requestOnBehalfData.CostCodeApproverEmailAddress :
                                employeeList !== null && employeeList.length > 0 ?
                                    employeeList[0].CostCodeApproverEmailAddress :
                                    'N/A'
                                }
                            size="15px"
                            containerClass="icon-container"
                        />
                             <Icons
                            customClassName="icon-mobile"
                            name="mobile-button"
                            labelValue={requestOnBehalfData.CostCodeApproverContatcNum != null ?
                                requestOnBehalfData.CostCodeApproverContatcNum :
                                    employeeList !== null && employeeList.length > 0 ?
                                    employeeList[0].CostCodeApproverContatcNum !== null ?
                                        employeeList[0].CostCodeApproverContatcNum :
                                        'N/A' :
                                    'N/A'
                                }
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icons
                            customClassName="icon-globe"
                            name="globe"
                            labelValue={requestOnBehalfData.CostCodeApproverLocation != null ?
                                requestOnBehalfData.CostCodeApproverLocation.CountryName :
                                    employeeList !== null && employeeList.length > 0 ?
                                    employeeList[0].CostCodeApproverLocation.CountryName :
                                    'N/A'
                                }
                            size="15px"
                            containerClass="icon-container"
                        />

                        <Icons
                            customClassName="icon-location"
                            name="location-dot"
                            labelValue={requestOnBehalfData.CostCodeApproverLocation != null ?
                                requestOnBehalfData.CostCodeApproverLocation.LocationSite + " - " + requestOnBehalfData.CostCodeApproverLocation.LocationCity + ", " + requestOnBehalfData.CostCodeApproverLocation.CountryName :
                                    employeeList !== null && employeeList.length > 0 && employeeList[0].CostCodeApproverLocation !== null ?
                                    employeeList[0].CostCodeApproverLocation.LocationSite + " - " + employeeList[0].CostCodeApproverLocation.LocationCity + ", " + employeeList[0].CostCodeApproverLocation.CountryName :
                                    'N/A'
                                }
                            size="15px"
                            containerClass="icon-container"
                        />
                    </div>
                </div>;
        } else {
            display =
                <div>
                    <h6 className="owner-detail-info-title"><Translation translationKey="approver_details" /></h6>                    
                    <h5 className="owner-detail-info-owner-name">
                        {Object.keys(newUser).length > 0 ? newUser.CostCodeApproverFullName ? newUser.CostCodeApproverFullName : ""  : data.CostCodeAuthorizer ? data.CostCodeAuthorizer.LastName + ', ' + data.CostCodeAuthorizer.FirstName + ' ' + (data.CostCodeAuthorizer.MiddleInitial !== "" ? data.CostCodeAuthorizer.MiddleInitial : "")
                        : 'N/A'}
                    </h5>
                    <div className="owner-detail-contacts">
                        <Icons
                            customClassName="icon-email"
                            name="envelope"
                            labelValue={Object.keys(newUser).length > 0 ? newUser.CostCodeApproverEmailAddress !== null ? newUser.CostCodeApproverEmailAddress : "N/A" :  data.CostCodeAuthorizer ? data.CostCodeAuthorizer.Email : 'N/A'}
                            size="15px"
                            containerClass="icon-container"
                        />
                             <Icons
                            customClassName="icon-mobile"
                            name="mobile-button"
                            labelValue={Object.keys(newUser).length > 0 ? newUser.CostCodeApproverContatcNum != null ? newUser.CostCodeApproverContatcNum : "N/A" : data?.CostCodeAuthorizer?.PrimarySubscription != null ? data.CostCodeAuthorizer?.PrimarySubscription : "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icons
                            customClassName="icon-globe"
                            name="globe"
                            labelValue={Object.keys(newUser).length > 0 ?  newUser.CostCodeApproverLocation.CountryName != null ? newUser.CostCodeApproverLocation.CountryName : "N/A" : data.CostCodeAuthorizer != null ? data.CostCodeAuthorizer.CountryName : "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />

                        <Icons
                            customClassName="icon-location"
                            name="location-dot"
                            labelValue={Object.keys(newUser).length > 0 ? newUser.CostCodeApproverLocation.CountryName ? newUser.CostCodeApproverLocation.LocationSite  + " - " + newUser.CostCodeApproverLocation.LocationCity + ", " + newUser.CostCodeApproverLocation.CountryName : "N/A" :data.CostCodeAuthorizer != null ? data.CostCodeAuthorizer.LocationSite + " - " + data.CostCodeAuthorizer.LocationCity + ", " + data.CostCodeAuthorizer.CountryName : "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />
                    </div>
                </div>;
        }

        return display;
    }

    renderRequesterDisplay = () => { 
        const { data } = this.props;
        const { requestOnBehalfData, employeeList } = this.props.createRequest;
        const { newUser } = this.props.wirelessChangeUserRequest
        let display;
        if (requestOnBehalfData.EmployeeId > 0 && Object.keys(newUser).length === 0) {
            display =
                <div>
                    <h5 className="owner-detail-info-owner-name">
                        {requestOnBehalfData.LastFirstName}
                    </h5>
                    <div className="owner-detail-contacts">
                        <Icons
                            customClassName="icon-email"
                            name="envelope"
                            labelValue={requestOnBehalfData.EmailAddress != null ? requestOnBehalfData.EmailAddress: "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icons
                            customClassName="icon-mobile"
                            name="mobile-button"
                            labelValue={requestOnBehalfData.PrimarySubscription != null ?
                                requestOnBehalfData.PrimarySubscription :
                                employeeList !== null && employeeList.length > 0 ?
                                employeeList[0].PrimarySubscription !== null ?
                                    employeeList[0].PrimarySubscription :
                                    'N/A' :
                                "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icons
                            customClassName="icon-globe"
                            name="globe"
                            labelValue={requestOnBehalfData.Country != null ? requestOnBehalfData.Country : "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />

                        <Icons
                            customClassName="icon-location"
                            name="location-dot"
                            labelValue={requestOnBehalfData.LocationModel != null ?
                                requestOnBehalfData.LocationModel.LocationSite + " - " + requestOnBehalfData.LocationModel.LocationCity + ", " + requestOnBehalfData.Country :
                                employeeList !== null && employeeList.length > 0 && employeeList[0].LocationModel !== null ?
                                    employeeList[0].LocationModel.LocationSite + " - " + employeeList[0].LocationModel.LocationCity + ", " + employeeList[0].LocationModel.CountryName :
                                    'N/A'
                            }
                            size="15px"
                            containerClass="icon-container"
                        />
                    </div>
                </div>;
        } else {
            display =
                <div>                   
                    <h5 className="owner-detail-info-owner-name">
                        {newUser.LastFirstName ?? `${data.LastName}, ${data.FirstName}`}
                    </h5>
                    <div className="owner-detail-contacts">
                        <Icons
                            customClassName="icon-email"
                            name="envelope"
                            labelValue={newUser.EmailAddress ? newUser.EmailAddress: data.Email}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icons
                            customClassName="icon-mobile"
                            name="mobile-button"
                            labelValue={newUser.PrimarySubscription ? newUser.PrimarySubscription != null ? newUser.PrimarySubscription : "N/A" : data.PrimarySubscription != null ? data.PrimarySubscription : "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icons
                            customClassName="icon-globe"
                            name="globe"
                            labelValue={newUser.Country ? newUser.Country != null ? newUser.Country : "N/A" : data.Location != null ? data.Location.CountryName : "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />

                        <Icons
                            customClassName="icon-location"
                            name="location-dot"
                            labelValue={newUser.LocationSiteCityCountry ? newUser.LocationSiteCityCountry != null ? newUser.LocationSiteCityCountry : "N/A" : data.Location != null ? data.Location.LocationSite + " - " + data.Location.LocationCity + ", " + data.Location.CountryName : "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />
                    </div>
                </div>;
        }

        return display;
    }

    render() {
        const { isLoading, typeId } = this.props;

        let isWireline = valueExist(WIRELINEREQUESTIDS, typeId);

        return (
            !isLoading ?
                <div className="owner-detail-info owner-detail-container">
                    <h6 className="owner-detail-info-title"><Translation translationKey="request_owner_details" /></h6>
                    {this.renderRequesterDisplay()}
                    {this.renderManagerDisplay(isWireline)}
                </div> : <div></div>
        );
    }
}

export default connect(
    state => {
        const { requestDetail, createRequest, wirelessChangeUserRequest } = state;
        return {
            ...requestDetail
            , createRequest
            , wirelessChangeUserRequest
        };
    },
    //dispatch =>
    //    bindActionCreators(
    //        Object.assign({}, requestDetailsActions),
    //        dispatch
    //    )
)(RequestOwnerDetails);